import { graphql } from "../generated";

export const SpecificationDocument = graphql(`
  query Specification($key: ID!) {
    specification(key: $key) {
      key
      sourceDeliverable {
        key
      }
      revisions {
        count
        nodes {
          id
          changeRequestIntegrationKey
          sequenceID
          # The revision's OWN governing deliverable key — the comment
          # preflights' exact target. The specification's sourceDeliverable
          # is only a fallback for cached pre-field rows; every revision in
          # the variation lane carries its own key.
          deliverableKey
          timestamp
          timestampStart
          timestampEnd
          timestampType
          category
          subCategory
          comment
          appliesToConcept
          # author is a federated Principal reference; its profile hop is
          # identity-api's, null for viewers without profile:read at the
          # tenancy (the same shape as the comment author below).
          author {
            key
            profile {
              key
              displayName
              avatar
            }
          }
          date
          resolved
          isRejected
          viewerOperationChecks(operations: [EDIT, ARCHIVE]) {
            operation
            authorization {
              passes
            }
            validation {
              passes
            }
          }
          annotations {
            id
            data
          }
          attachments {
            id
            file {
              key
              fileName
              size
              url
            }
          }
          comments {
            items {
              ...RevisionCommentFields
              # Inline twin of @creative-revision/revision's
              # CommentOperationChecks fragment (codegen documents are scanned
              # per package) — keep the two in lockstep.
              viewerOperationChecks(operations: [EDIT, REMOVE]) {
                operation
                authorization {
                  passes
                }
                validation {
                  passes
                }
              }
            }
          }
        }
      }
    }
  }

  # Twin of @creative-revision/revision's RevisionCommentFields fragment
  # (codegen documents are scanned per package) — keep the two in lockstep.
  # author is a federated Principal reference; its profile hop is
  # identity-api's, null for viewers without profile:read at the tenancy.
  fragment RevisionCommentFields on Comment {
    id
    message
    author {
      key
      profile {
        key
        displayName
        avatar
      }
    }
    visibility
    isRejection
    createdAt
  }
`);
